import React from 'react';
import AddInventoryTransactionForm from './AddInventoryTransactionForm';

function AddPreparation(props) {
    return (
        <AddInventoryTransactionForm
            {...props}
            title="Submit New Items Prepared today"
            listEndpoint="/pos/inventory/list/in_house_preps/"
            submitEndpoint="/pos/inventory/update/in_house_preps/"
            successMessage="Inventory Updated"
            navigateTo="/inventory/view"
            showAlreadyAddedColumn
        />
    );
}

export default AddPreparation;
